<template>
  <div style="height: 100%;display: flex;flex-direction: row;">
    <PurchasePlan @reload="detailKey++" style="width: 250px; height: unset; flex: unset;" @item-choose="item => chooseData = item" />
    <PurchaseDetail :key="detailKey" v-if="chooseData" :goodsPurchaseId="chooseData.id" style="flex: 1; width: 0;height: unset;margin-left: 0;padding: 0;" />
  </div>
</template>

<script>
import PurchaseDetail from './detail.vue'
import PurchasePlan from '../../components/goods/purchase/plan.vue'

export default {
  components: { PurchasePlan, PurchaseDetail },
  props: {},
  data () {
    return {
      chooseData: null,
      detailKey: 0
    }
  }
}
</script>
